// extracted by mini-css-extract-plugin
export var blueBackground = "IntroBanner-module--blueBackground--3329a";
export var buttonsWrapp = "IntroBanner-module--buttonsWrapp--4397d";
export var fullImage = "IntroBanner-module--fullImage--b3c20";
export var fullImageWrapper = "IntroBanner-module--fullImageWrapper--20dba";
export var heading = "IntroBanner-module--heading--dd827";
export var imageBottomOnMobile = "IntroBanner-module--imageBottomOnMobile--1421c";
export var intro = "IntroBanner-module--intro--a30f1";
export var section = "IntroBanner-module--section--27e60";
export var subHeading = "IntroBanner-module--subHeading--5bed3";
export var textLogo = "IntroBanner-module--textLogo--f5951";
export var title = "IntroBanner-module--title--6108b";
export var titleText = "IntroBanner-module--titleText--24983";
export var white = "IntroBanner-module--white--a2a96";
export var wrapper = "IntroBanner-module--wrapper--ec876";